import BasicCRMModal from './BasicCRMModal';

export default BasicCRMModal;
